/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getBeds } from 'app/entities/bed/bed.reducer';
import { getEntities as getRooms } from 'app/entities/room/room.reducer';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { InwardChargeType } from 'app/shared/model/enumerations/inward-charge-type.model';
import { createEntity, getEntity, reset, updateEntity } from './ward-charges.reducer';

export const WardChargesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const beds = useAppSelector(state => state.bed.entities);
  const rooms = useAppSelector(state => state.room.entities);
  const wardChargesEntity = useAppSelector(state => state.wardCharges.entity);
  const loading = useAppSelector(state => state.wardCharges.loading);
  const updating = useAppSelector(state => state.wardCharges.updating);
  const updateSuccess = useAppSelector(state => state.wardCharges.updateSuccess);
  const chargeTypeValues = Object.keys(ChargeType);
  const inwardChargeTypeValues = Object.keys(InwardChargeType);

  const handleClose = () => {
    navigate(`/ward-charges${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getBeds({}));
    dispatch(getRooms({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.charge !== undefined && typeof values.charge !== 'number') {
      values.charge = Number(values.charge);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...wardChargesEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      bed: beds.find(it => it.id.toString() === values.bed?.toString()),
      room: rooms.find(it => it.id.toString() === values.room?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          chargeType: 'HOURLY',
          inwardChargeType: 'AdmissionFee',
          ...wardChargesEntity,
          hospital: wardChargesEntity?.hospital?.id,
          scheme: wardChargesEntity?.scheme?.id,
          bed: wardChargesEntity?.bed?.id,
          room: wardChargesEntity?.room?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.wardCharges.home.createOrEditLabel" data-cy="WardChargesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.wardCharges.home.createOrEditLabel">Create or edit a WardCharges</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ward-charges-id"
                  label={translate('tinyMedicRestApp.wardCharges.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.name')}
                id="ward-charges-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.description')}
                id="ward-charges-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.relatedTo')}
                id="ward-charges-relatedTo"
                name="relatedTo"
                data-cy="relatedTo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.charge')}
                id="ward-charges-charge"
                name="charge"
                data-cy="charge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.chargeType')}
                id="ward-charges-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="select"
              >
                {chargeTypeValues.map(chargeType => (
                  <option value={chargeType} key={chargeType}>
                    {translate(`tinyMedicRestApp.ChargeType.${chargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.inwardChargeType')}
                id="ward-charges-inwardChargeType"
                name="inwardChargeType"
                data-cy="inwardChargeType"
                type="select"
              >
                {inwardChargeTypeValues.map(inwardChargeType => (
                  <option value={inwardChargeType} key={inwardChargeType}>
                    {translate(`tinyMedicRestApp.InwardChargeType.${inwardChargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.active')}
                id="ward-charges-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.microSec')}
                id="ward-charges-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.timestampentry')}
                id="ward-charges-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.lastupdated')}
                id="ward-charges-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.cursor')}
                id="ward-charges-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.tax')}
                id="ward-charges-tax"
                name="tax"
                data-cy="tax"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.multiplierApplied')}
                id="ward-charges-multiplierApplied"
                name="multiplierApplied"
                data-cy="multiplierApplied"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.startDate')}
                id="ward-charges-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.endDate')}
                id="ward-charges-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.suspended')}
                id="ward-charges-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.wardCharges.draft')}
                id="ward-charges-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                id="ward-charges-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.wardCharges.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="ward-charges-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.wardCharges.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="ward-charges-bed"
                name="bed"
                data-cy="bed"
                label={translate('tinyMedicRestApp.wardCharges.bed')}
                type="select"
              >
                <option value="" key="0" />
                {beds
                  ? beds.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="ward-charges-room"
                name="room"
                data-cy="room"
                label={translate('tinyMedicRestApp.wardCharges.room')}
                type="select"
              >
                <option value="" key="0" />
                {rooms
                  ? rooms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ward-charges" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WardChargesUpdate;
